import {CoreObjectArchiveData} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {FieldDefinitionType} from 'graphql-client/__generated/graphqlGlobalTypes';

export const LIBRARY_PARAMETER_DEFINITION_DATA_TYPES = [
  FieldDefinitionType.FLOAT,
  FieldDefinitionType.TEXT,
  FieldDefinitionType.DATETIME,
  FieldDefinitionType.DROPDOWN,
];

export function isLibraryParameterDefinitionDataType(
  dataType: FieldDefinitionType
): dataType is LibraryParameterDefinitionDataType {
  return LIBRARY_PARAMETER_DEFINITION_DATA_TYPES.includes(dataType);
}

export type LibraryParameterDefinitionDataType =
  | FieldDefinitionType.FLOAT
  | FieldDefinitionType.TEXT
  | FieldDefinitionType.DATETIME
  | FieldDefinitionType.DROPDOWN;

export interface LibraryParameterDefinitionDropdown {
  id: string;
  name: string;
}

export interface LibraryParameterDefinition {
  id: string;
  name: string;
  dataType: LibraryParameterDefinitionDataType;
  unitType: {id: string; name: string} | null;
  dropdown: LibraryParameterDefinitionDropdown | null;
  description: string | null;
  archiveData: CoreObjectArchiveData;
}

/** Id and name only (e.g. parameter-library search query and slim typed values). */
export type LibraryParameterDefinitionIdName = Pick<LibraryParameterDefinition, 'id' | 'name'>;
